import   services   from "./services"

export default {
    services: {
        chatbot: services.chatbot,
        tools: services.tools,
        cloudflare: services.cloudflare,
    }
}